module.exports = __webpack_public_path__ + "img/inside-out-maki.524ea68a.png";